export default{
  /* "key":"value" */
  "langauge-en" : "영어",
  "langauge-ko" : "한국어",

  "main.description" : "<p>고객이 사용하는 채팅 속에 브랜드를 인지시키는 가장 쉽고 확실한 방법.</p><p>mojitok ADsticker를 만나보세요.</p>",

  "about.title" : "ADsticker란?",
  "about.description" : "<p>사용자가 채팅창에 특정 단어, 문맥, 상황을 입력할 때</p><p>브랜드의 홍보 콘텐츠를 정교하게 보여주는 스티커 형태의 광고 상품입니다.</p><pit>※스티커란, mojitok 플랫폼에서 사용되는 이모티콘을 말합니다.</pit>",
  "about.btn.contactUs": "지금 바로 ADsticker<p>무료 컨설팅을 신청하세요</p>",

  "feature.title" : "ADsticker의 주요 혜택",
  "feature.guarantee.title" : "노출 수 보장형 상품",
  "feature.guarantee.description" : "<p>광고 집행 기간 내, ADsticker의</p><p>노출 수 총 합을 보장합니다.</p>",
  "feature.matching.title" : "크리에이터 매칭 서비스",
  "feature.matching.description" : "스티커 제작이 어려워도 걱정마세요. 크리에이터와의 협업을 통해, 쉽고 간편하게 광고 스티커를 제작할 수 있습니다.",
  "feature.channels.title" : "다양한 제휴 채널",
  "feature.channels.description" : "ADsticker는 mojitok 서비스에서 전개되며, 제휴된 다양한 메신저 내 3억 명의 사용자들에게 노출됩니다. <pit>mojitok은 다양한 메신저 서비스에 적용 가능한 지능형 스티커 API/SDK 입니다.</pit>",

  "keyword.title" : "브랜드 연관 키워드에 타겟팅",
  "keyword.description" : "<p>F&B / 금융 / 패션 & 쇼핑 / 모빌리티 & 배송 서비스 / 애플리케이션 등</p><p>홍보에 효과적</p>",

  "targetBranding.btn" : "<p>매일 업데이트되는 ADsticker</p>마케팅 정보가 궁금하다면, 클릭!",

  "contact.title": "<p>지금 바로 mojitok ADsticker</p><p><strong>마케팅 필승 전략</strong>을 받아보세요.</p><p><strong>무료로 컨설팅을 제공드립니다.</strong></p>",
  "contact.required" : "<t>*</t>필수입력 사항",
  "contact.form.radio.brand" : "브랜드",
  "contact.form.radio.agency" : "에이전시",

  "contact.form.companyName" : "브랜드/에이전시 명",
  "contact.form.companyName.required" : "브랜드/에이전시 명을 입력하세요.",
  "contact.form.companyDescription" : "설명",
  "contact.form.name" : "담당자 이름",
  "contact.form.name.required" : "담당자 이름을 입력하세요.",
  "contact.form.email" : "이메일 주소",
  "contact.form.email.required" : "연락 가능한 이메일 주소를 입력하세요.",
  "contact.form.email.type" : "유효하지 않은 이메일 주소입니다.",
  "contact.form.phoneNumber" : "담당자 전화번호",
  "contact.form.message" :"문의 내용",
  "contact.form.message.required" : "문의 내용을 입력하세요.",
  "contact.button" : "마케팅 컨설팅 신청하기" 
}